module.exports = __webpack_public_path__ + "img/01.b2c5f3f9.png";